import React, { useState, useEffect } from "react";
import styles from "./SuggestedUsersPage.module.css";
import {
  useGetUsersByFollowersQuery,
  useFollowUserMutation,
  useUnfollowUserMutation,
} from "../store/api/followApi";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

// Skeleton card shown while loading
function SkeletonCard() {
  return (
    <div className={styles.skeletonCard}>
      <div className={styles.skeletonTop} />
      <div className={styles.skeletonAvatar} />
      <div className={styles.skeletonLine} style={{ width: "60%" }} />
      <div className={styles.skeletonLine} style={{ width: "40%" }} />
      <div className={styles.skeletonLine} style={{ width: "80%", marginTop: 4 }} />
    </div>
  );
}

export default function SuggestedUsersPage() {
  const { data: users = [], isLoading } = useGetUsersByFollowersQuery();
  const [followUser] = useFollowUserMutation();
  const [unfollowUser] = useUnfollowUserMutation();
  const [localUsers, setLocalUsers] = useState([]);
  const [loadingUser, setLoadingUser] = useState(null);
  const navigate = useNavigate();

useEffect(() => {
  // only initialize once
  if (localUsers.length === 0 && users.length > 0) {
    setLocalUsers(users);
  }
}, [users]);

  const handleProfileClick = (userId) => {
    if (!userId) return;
    navigate(`/profile/${userId}`);
  };

const handleFollow = async (e, user) => {
  e.stopPropagation();

  setLoadingUser(user.id);

  // Optimistic update
  setLocalUsers((prev) =>
    prev.map((u) =>
      u.id === user.id
        ? {
            ...u,
            isFollowing: !u.isFollowing,
          }
        : u
    )
  );

  try {
    if (user.isFollowing) {
      await unfollowUser(user.id).unwrap();
    } else {
      await followUser(user.id).unwrap();
    }
  } catch (err) {
    console.error("Follow action failed", err);

    // rollback
    setLocalUsers((prev) =>
      prev.map((u) =>
        u.id === user.id
          ? {
              ...u,
              isFollowing: user.isFollowing,
            }
          : u
      )
    );
  } finally {
    setLoadingUser(null);
  }
};


  return (
    <div className={styles.wrapper}>
      <Header />

      <div className={styles.container}>
        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>Suggested for You</h1>
          <p className={styles.pageSubtitle}>
            Expand your circle — discover people worth knowing.
          </p>
        </div>

        {isLoading ? (
          <div className={styles.loadingGrid}>
            {Array.from({ length: 8 }).map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : (
          <div className={styles.userGrid}>
            {localUsers.length === 0 ? (
              <div className={styles.emptyState}>
                <span className={styles.emptyIcon}>🔍</span>
                No suggestions available right now.
              </div>
            ) : (
              localUsers.map((user) => (
                <div
                  key={user.id}
                  className={styles.card}
                  onClick={() => handleProfileClick(user.id)}
                >
                  <div className={styles.avatarWrap}>
                    {user.profilePhotoUrl ? (
                      <img
                        src={user.profilePhotoUrl}
                        alt={user.name}
                        className={styles.avatar}
                      />
                    ) : (
                      <div className={styles.avatarFallback}>
                        {user.name?.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>

                  <span className={styles.name}>{user.name}</span>

                  {user.userType && (
                    <span className={styles.userType}>{user.userType}{user.userType === 'Rookie' && user.rookieType
              ? ` (${user.rookieType})`
              : ''}</span>
                  )}

                  {user.bio && (
                    <p className={styles.bio}>{user.bio}</p>
                  )}

                  {user.state && (
                    <p className={styles.followers}>
                      {user.state}
                    </p>
                  )}

                  <button
                    className={user.isFollowing ? styles.unfollowBtn : styles.followBtn}
                    onClick={(e) => handleFollow(e, user)}
                    disabled={loadingUser === user.id}
                  >
                    {loadingUser === user.id
                      ? "…"
                      : user.isFollowing
                      ? "Following"
                      : "Follow"}
                  </button>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}